var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _MedicationPrescribedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import PrescriptionJournalEvent from "./prescription-journal-event";
import MedicationRequest from "./prescriptions/medication-request";

//---- Automatically generated, don't update this part ----
/**
 * An event created when a Medic prescibes drugs to a Patient.
 * It contains a list of medication, and a custom field letting the
 * Medic enter additional medication manually.
 */
let MedicationPrescribedJournalEvent = (_dec = attr("string"), _dec2 = attr("medication-requests", {
  defaultValue() {
    return [];
  }
}), _dec3 = attr("string"), _dec4 = attr("string"), _dec5 = attr(), _dec6 = attr("boolean", {
  allowNull: true
}), _dec7 = belongsTo("patient", {
  async: false,
  inverse: "medicationPrescribedJournalEvents"
}), _dec8 = attr("string"), _class = (_MedicationPrescribedJournalEvent = class MedicationPrescribedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    /**
     * Validity period of the prescription, [duration-unit]
     */
    _initializerDefineProperty(this, "validityPeriod", _descriptor, this);
    /**
     * A list of prescribed medication
     */
    _initializerDefineProperty(this, "medications", _descriptor2, this);
    /**
     * Additional drugs that can be prescribed in ALD
     */
    _initializerDefineProperty(this, "otherMedicationsAld", _descriptor3, this);
    /**
     * Additional drugs that can be prescribed
     */
    _initializerDefineProperty(this, "otherMedications", _descriptor4, this);
    /**
     * Identity of the prescriptor if different than the creator of the prescription.
     * A key-value object representing the prescriptor identity.
     *
     * For instance:
     *
     * ```js
     * {
     *   "first-name": "Jane",
     *   "last-name": "Doe",
     *   "professional-id": "123456"
     * }
     * ```
     */
    _initializerDefineProperty(this, "prescriptorIdentity", _descriptor5, this);
    /**
     * The rules should create an alert or not when the prescription expires soon
     */
    _initializerDefineProperty(this, "createExpirationAlert", _descriptor6, this);
    //---- End of generated code ----
    _initializerDefineProperty(this, "patient", _descriptor7, this);
    /**
     * @type {string}
     */
    _initializerDefineProperty(this, "uuid", _descriptor8, this);
  }
  static validations(intl) {
    return {
      validityPeriod: [validatePresence({
        presence: true,
        description: intl.t("validations.medication-prescribed-journal-event.validity-period")
      }), validateInclusion({
        list: ["1-day", "2-days", "3-days", "4-days", "5-days", "6-days", "7-days", "8-days", "9-days", "10-days", "11-days", "12-days", "13-days", "1-week", "2-weeks", "3-weeks", "1-month", "2-months", "3-months", "4-months", "5-months", "6-months", "1-year"],
        description: intl.t("validations.medication-prescribed-journal-event.validity-period")
      })],
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.medication-prescribed-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
        onOrBefore: dayjs().endOf("day").toDate()
      })]
    };
  }
  get startDate() {
    return this.occurredAt;
  }
  get endDate() {
    if (!this.validityPeriod) {
      return;
    }
    const endDate = new Date(this.startDate);
    const validityPeriodDuration = Number.parseInt(this.validityPeriod.split("-")[0]);
    const validityPeriodUnit = this.validityPeriod.split("-")[1];
    if (validityPeriodUnit?.includes("day")) {
      return new Date(endDate.setDate(endDate.getDate() + validityPeriodDuration));
    } else if (validityPeriodUnit?.includes("week")) {
      return new Date(endDate.setDate(endDate.getDate() + validityPeriodDuration * 7));
    }
    return new Date(endDate.setMonth(endDate.getMonth() + validityPeriodDuration));
  }
  async renew() {
    return this.store.createRecord("medication-prescribed-journal-event", {
      occurredAt: new Date(),
      patient: this.patient,
      validityPeriod: this.validityPeriod,
      medications: this.medications,
      otherMedicationsAld: this.otherMedicationsAld,
      otherMedications: this.otherMedications
    }).save();
  }
  get pdfUrl() {
    return `/api/v1/medication_prescriptions/${this.id}`;
  }
}, _defineProperty(_MedicationPrescribedJournalEvent, "type", "medication-prescribed-journal-event"), _MedicationPrescribedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "validityPeriod", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "medications", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "otherMedicationsAld", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "otherMedications", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "prescriptorIdentity", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "createExpirationAlert", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "uuid", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicationPrescribedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.